export default "__VITE_ASSET__fDb_JIqF$Cv5BGquyHUT1Q__"